import { render, staticRenderFns } from "./materialRecipe.vue?vue&type=template&id=4f8026cb&scoped=true&"
import script from "./materialRecipe.vue?vue&type=script&lang=js&"
export * from "./materialRecipe.vue?vue&type=script&lang=js&"
import style0 from "./materialRecipe.vue?vue&type=style&index=0&id=4f8026cb&prod&lang=scss&"
import style1 from "./materialRecipe.vue?vue&type=style&index=1&id=4f8026cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8026cb",
  null
  
)

export default component.exports